import { render } from "./info-promo-popup.vue?vue&type=template&id=32afb5b3"
import script from "./info-promo-popup.vue?vue&type=script&lang=js"
export * from "./info-promo-popup.vue?vue&type=script&lang=js"
script.render = render

export default script